import { StrictMode } from 'react'
import ReactDOM from 'react-dom/client'
import { BrowserRouter } from 'react-router-dom'
import App from './App.tsx'
import './styles/main.css'
import './styles/pwa.css'
import 'bootstrap/dist/css/bootstrap.min.css'
import './utils/fontawesome'
import AnalyticsTracker from './components/analytics/AnalyticsTracker'

// Service worker is handled by vite-plugin-pwa automatically
// No need for manual registration

ReactDOM.createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <BrowserRouter>
      <AnalyticsTracker>
        <App />
      </AnalyticsTracker>
    </BrowserRouter>
  </StrictMode>,
)
